import { Field, Model, CodeModel, FIELD_TYPES } from "@/vue-ocom/schema";

export default Model("document_notification_rule", {
  verbose_name: "Document Notification Rule",
  verbose_name_plural: "Document Notification Rules",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("doc_category", {
      label: "Document Category",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.Array,
      default: () => {
        return [];
      },
    }),
    Field("employee_depot", {
      label: "Employee Depot",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeDepot",
      ref_display_field: "description",
      default: () => {
        return null;
      },
    }),
    Field("employee_depot__description", {
      label: "Employee Depot",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("employee_category", {
      label: "Employee Category",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeEmployeeCategory",
      ref_display_field: "description",
      default: () => {
        return null;
      },
    }),
    Field("employee_category__description", {
      label: "Employee Category",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("employee_type", {
      label: "Employee Type",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeEmployeeType",
      ref_display_field: "description",
      default: () => {
        return null;
      },
    }),
    Field("employee_type__description", {
      label: "Employee Type",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("employee", {
      label: "Employee",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Employee",
      ref_display_field: "first_name",
      default: () => {
        return null;
      },
    }),
    Field("employee__first_name", {
      label: "Employee",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("active_start_date", {
      label: "Active Start Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date();
      },
    }),
    Field("active_end_date", {
      label: "Active End Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("rule_type", {
      label: "Rule Type",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return 0;
      },
    }),
  ],
});
